if (!customElements.get('picker-popup')) {
  class PickerPopup extends HTMLElement {
    constructor() {
      super();

      this.content = this.querySelector('[data-content]');
      this.button = this.querySelector('[data-button]');
      this.onButtonClick = this.onButtonClick.bind(this);
      this.onContentClick = this.onContentClick.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
    }

    connectedCallback() {
      if (!this.button || !this.content) return;

      this.button.addEventListener('click', this.onButtonClick);
      this.content.addEventListener('click', this.onContentClick);
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener('click', this.onButtonClick);
      }
      if (this.content) {
        this.content.removeEventListener('click', this.onContentClick);
      }
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
    }

    isMobileViewport() {
      return window.matchMedia('(max-width: 999px)').matches;
    }

    onButtonClick(event) {
      // On desktop, CSS hover/focus handles reveal.
      if (!this.isMobileViewport()) return;

      event.preventDefault();
      event.stopPropagation();

      if (this.hasAttribute('data-active')) {
        this.closeContent();
      } else {
        this.openContent();
      }
    }

    onDocumentClick(event) {
      if (!this.isMobileViewport()) return;
      if (!this.hasAttribute('data-active')) return;
      if (this.contains(event.target)) return;
      this.closeContent();
    }

    onContentClick() {
      if (!this.isMobileViewport()) return;
      if (!this.hasAttribute('data-active')) return;
      this.closeContent();
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.closeContent();
      }
    }

    openContent() {
      this.setAttribute('data-active', '');
      this.button?.setAttribute('aria-expanded', 'true');
    }

    closeContent() {
      this.removeAttribute('data-active');
      this.button?.setAttribute('aria-expanded', 'false');
      this.button?.blur();
    }
  }

  customElements.define('picker-popup', PickerPopup);
}
